module.exports = __webpack_public_path__ + "static/media/vklogo.8f0e066a.png";